/** UK racing form / finishing abbreviations shown in recent-form strings. */

const RECENT_FORM_CODES: Record<string, string> = {
  UR: 'Unseated rider — the jockey came off without the horse having fallen.',
  U: 'Unseated rider (abbreviated).',
  PU: 'Pulled up — the jockey stopped the horse before the finish (often tired or outpaced; not always injured).',
  P: 'Pulled up (abbreviated).',
  BD: 'Brought down — the horse was brought down by another faller.',
  REF: 'Refused — the horse refused to race or to jump an obstacle.',
  R: 'Refused (abbreviated).',
  F: 'Fell — the horse fell during the race.',
  RO: 'Ran out — the horse left the course (e.g. ran past a fence).',
  SU: 'Slipped up — the horse slipped and could not continue.',
  DSQ: 'Disqualified after the race.',
  D: 'Disqualified (abbreviated).',
  BF: 'Beaten favourite — favourite in the betting but did not win.',
  NR: 'Non-runner — declared but did not start.',
  VO: 'Void — no official result for betting on this run.',
  V: 'Void (abbreviated).',
  WD: 'Withdrawn before the start.',
  W: 'Withdrawn (abbreviated).',
  LFT: 'Left at the start — did not complete the start procedure.',
  CO: 'Carried out — continued after an incident by order of the stewards (context-dependent).',
};

export function isNumericFinishingPosition(value: string): boolean {
  return /^\d+$/.test(value.trim());
}

export function getRecentFormCodeTooltip(code: string): string {
  const key = code.trim().toUpperCase();
  return (
    RECENT_FORM_CODES[key] ??
    `Racing form code “${code.trim()}”. See your racecard or programme for the official definition.`
  );
}

/** Last `(…)` at end of segment is treated as finishing position, e.g. `Southwell (AW) (6)`. */
export function extractTrailingPosition(segment: string): { prefix: string; pos: string | null } {
  const s = segment.trim();
  const lastOpen = s.lastIndexOf('(');
  if (lastOpen < 0) return { prefix: s, pos: null };
  const lastClose = s.lastIndexOf(')');
  if (lastClose <= lastOpen || lastClose !== s.length - 1) {
    return { prefix: s, pos: null };
  }
  const inner = s.slice(lastOpen + 1, lastClose).trim();
  const prefix = s.slice(0, lastOpen).trimEnd();
  return { prefix, pos: inner };
}
